import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  info,
  error,
  warning
} from "../../../../../store/notification/actions";

export const uploadEdi = (data) => {
  if (data != null) {
      const headers = {
        'Accept': 'multipart/form-data',
        'content-type': 'multipart/form-data'
      }
      return axiosInstance
        .post("/ancillary/edi/uploadEdi",
          data,{headers},
          )
          .then((response) => {
            if (response.data.status === "success") {
              success("File Uploaded and Extracted successfully");
              return { message: "", hasError: false, data: response.data.data };
            } else {
              error(response.data.error[0].message);
              return { message: "upload failed", hasError: true, data: "" };
            }
          })
          .catch((err) => {
            error(err.response.data.error[0].message);
            return {
              message: err.response.data.error[0].message,
              hasError: true,
              data: "",
            };
          });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}

export const getEdiInvoiceStage = (data) =>{
  if (data != null) {
    info("Loading data...");
    return axiosInstance
      .post("/ancillary/edi/getEdiInvoiceStage",data)
      .then((response) => {
        if (response.data.status === "success") {
          success("Data Fetched Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}

export const getInvoiceLogs = (data) =>{
  if (data != null) {
    info("Loading EDI logs...");
    return axiosInstance
      .post("/ancillary/edi/getInvoiceLogInfo", data)
      .then((response) => {
        if (response.data.status === "success") {
          success("Data Fetched Successfully");
          if(response.data.data && response.data.data.length <= 0) {
            warning("No Logs Found")
          }
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}


export const getInvoiceLogsByDate = (data) =>{
  if (data != null) {
    info("Loading EDI log detaiils...");
    return axiosInstance
      .post("/ancillary/edi/getInvoiceLogInfoByDate", data)
      .then((response) => {
        if (response.data.status === "success") {
          success("Data Fetched Successfully");
          if(response.data.data && response.data.data.length <= 0) {
            warning("No Logs Found")
          }
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}

export const reconcile = (data) =>{
  if (data != null) {
    info("Reconciling...");
    return axiosInstance
      .post("/ancillary/edi/reconsile",data)
      .then((response) => {
        if (response.data.status === "success") {
          success("Reconciled Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}

export const truncateEdi = (data) =>{
  if (data != null) {
    return axiosInstance
      .post("/ancillary/edi/truncate",data)
      .then((response) => {
        if (response.data.status === "success") {
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}

export const RequestEDI = (data) =>{
  if (data != null) {
    info("Requesting...");
    return axiosInstance
      .post("/ancillary/edi/raiseEdiRequest",data)
      .then((response) => {
        if (response.data.status === "success") {
          success("Request Raised Successfully");
          return { message: "", hasError: false, data: response.data.data };
        } else {
          error(response.data.error[0].message);
          return {
            message: response.data.error[0].message,
            hasError: true,
            data: "",
          };
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });
    }
    else {
      return { message: "Internal error occurred", hasError: true, data: "" };
    }
}